import { render, staticRenderFns } from "./dui-loading-indicator.vue?vue&type=template&id=9d0906a2&"
import script from "./dui-loading-indicator.vue?vue&type=script&lang=js&"
export * from "./dui-loading-indicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports